/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ExpandMore } from '@mui/icons-material';
import { textFieldStyles } from '../../Configurations/ExpenseEntryConfig';

const styles = makeStyles((theme) => textFieldStyles(theme));

const ExpenseTextField = (props) => {
    const classes = styles();
    const { startAdornment, endAdornment } = props;
    const excludedProps = ['startAdornment', 'endAdornment', 'isViewOnly'];
    const includedProps = Object.keys(props).reduce((acc, key) => {
        const result = acc;
        if (!excludedProps.includes(key)) {
            result[key] = props[key];
        }
        return result;
    }, {});

    return (
        <TextField
            classes={{ root: classes.root }}
            sx={() => ({
                '& .MuiInputBase-root': {
                    marginTop: '0',
                },
                '& .MuiInputLabel-shrink': {
                    transform: 'translate(0, 1.5px) scale(0.75) !important',
                },
            })}
            InputProps={{
                classes: {
                    root: classes.inputRoot,
                    input: classes.input,
                    focused: classes.focused,
                    multiline: classes.multiline,
                    error: classes.error,
                    disabled: classes.disabled,
                    cursor: classes.cursor,
                },
                shrink: true,
                disableunderline: 'true',
                disableUnderline: true,
                startAdornment: startAdornment && startAdornment,
                endAdornment: endAdornment && endAdornment,
            }}
            InputLabelProps={{
                shrink: true,
                classes: {
                    asterisk: classes.inputLabelAsterisk,
                },
                disableUnderline: true,
            }}
            SelectProps={{
                shrink: true,
                classes: { icon: classes.selectIcon },
                IconComponent: ExpandMore,
                displayEmpty: true,
                MenuProps: { MenuListProps: { id: props.id && `${props.id}-menu` } },
                disableUnderline: true,
            }}
            variant="standard"
            {...includedProps}
        >
            {props.select && props.children}
        </TextField>
    );
};

export default ExpenseTextField;
